import { render, staticRenderFns } from "./choiceProxyDevice.vue?vue&type=template&id=45d33f1c&scoped=true"
import script from "./choiceProxyDevice.vue?vue&type=script&lang=js"
export * from "./choiceProxyDevice.vue?vue&type=script&lang=js"
import style0 from "./choiceProxyDevice.vue?vue&type=style&index=0&id=45d33f1c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d33f1c",
  null
  
)

export default component.exports